<!--
 * @Descripttion: 选项卡组件
 * @Author: zenghua.wang
 * @Date: 2022-01-10 10:15:00
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-02-11 16:56:17
-->
<template>
  <div
    :class="setClass()"
    :style="styleSize"
  >
    <el-tabs
      v-model="option.currentTab"
      :type="option.type"
      :tab-position="option.position"
      @tab-click="onTab"
    >
      <el-tab-pane
        v-for="(tab,tabIndex) in children"
        :key="tabIndex"
        :label="tab.label"
        :name="tab.name"
      >
        <draggable
          :class="setClass('panel', {noborder: disabled})"
          :style="stylePanel"
          :list="tab.children"
          :group="{ name: 'form' }"
          ghost-class="ghost"
          :animation="200"
          :disabled="disabled"
          :scroll="true"
          @add="onWidgetTabsAdd($event, tabIndex)"
        >
          <template v-if="tab.children && tab.children.length > 0">
            <div
              v-for="(item, index) in tab.children"
              :key="index"
              :class="setClass('item')"
              @click.stop="onSelectWidgetTabs(tabIndex, index)"
            >
              <div
                :class="setClass('item__content')"
                :style="styleInline(item)"
              >
                <!-- 动态组件占位 -->
                <component
                  :is="`drag-${item.type}`"
                  :id="item.prop"
                  :label="item.label"
                  :apiId="item.apiId"
                  :width="item.width"
                  :height="item.height"
                  :option="item.option"
                  :children="item.children"
                  :temp="item.temp"
                  :page="item.page"
                  :index="index"
                  :disabled="disabled"
                  :select.sync="select"
                  @change="$emit('change')"
                >
                </component>

                <div
                  v-if="selectWidget && selectWidget.prop == item.prop && !disabled"
                  :class="setClass('item__action')"
                >
                  <el-button
                    title="上移"
                    @click.stop="onWidgetTabsMove(item, tabIndex, index, 'up')"
                    circle
                    plain
                    size="small"
                    type="primary"
                  >
                    <i class="el-icon-top"></i>
                  </el-button>

                  <el-button
                    title="下移"
                    @click.stop="onWidgetTabsMove(item, tabIndex, index, 'down')"
                    circle
                    plain
                    size="small"
                    type="primary"
                  >
                    <i class="el-icon-bottom"></i>
                  </el-button>

                  <el-button
                    title="复制"
                    @click.stop="onWidgetTabsClone(tabIndex, index)"
                    circle
                    plain
                    size="small"
                    type="primary"
                  >
                    <i class="el-icon-document-copy"></i>
                  </el-button>

                  <el-button
                    title="删除"
                    @click.stop="onWidgetTabsDelete(tabIndex, index)"
                    circle
                    plain
                    size="small"
                    type="danger"
                  >
                    <i class="el-icon-delete"></i>
                  </el-button>
                </div>
              </div>
            </div>
          </template>

          <!-- 占位符-->
          <div
            v-else
            class="drag-empty"
            :style="styleVisible"
          />
        </draggable>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
import { component } from '@/dragComponents/model/default.js'
import { isEmpty, createId, deepClone } from '@/dragComponents/utils'
import bem from '@/dragComponents/mixins/bem'

export default {
  name: 'drag-tabs',
  mixins: [bem],
  components: {
    draggable
  },
  inject: ['category', 'device'],
  props: {
    id: {
      type: String
    },
    option: {
      type: Object,
      default: () => {
        return {}
      }
    },
    children: {
      type: Array,
      default: () => {
        return []
      }
    },
    index: {
      type: [Number, String]
    },
    select: {
      type: Object,
      default: () => {
        return {}
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectWidget: this.select
    }
  },
  computed: {
    styleSize() {
      const { design } = component
      return Object.assign(
        (() => {
          // 设计时
          if (!this.disabled) {
            return {
              background: this.category === 'report' ? design.bg : 'none',
              border: (() => {
                return this.styleActive ? design.activeDashed : '0'
              })()
            }
          }
          return {}
        })(),
        {
          width: '100%',
          background: '#fff'
        }
      )
    },
    stylePanel() {
      return Object.assign(
        (() => {
          // 设计时
          if (!this.disabled) {
            return {
              background: this.category === 'report' ? '#f7f7f7' : 'none',
              margin: '0 12px 12px'
            }
          }
          return {}
        })(),
        {}
      )
    },
    styleActive() {
      return !this.disabled && this.select.prop === this.id
    },
    styleInline() {
      return (item) => {
        let block = (component.inlineList || []).includes(item.type)
          ? 'inline-block'
          : 'block'
        return {
          display: block
        }
      }
    },
    styleVisible() {
      return {
        display: this.disabled ? 'none' : 'block'
      }
    }
  },
  watch: {
    select(val) {
      this.selectWidget = val
    },
    selectWidget: {
      handler(val) {
        this.$emit('update:select', val)
      },
      deep: true
    }
  },
  methods: {
    onWidgetTabsAdd(e, tabIndex) {
      let newIndex = e.newIndex
      // 不允许拖入自己
      // if (this.children[newIndex] && this.children[newIndex].type !== 'tabs') {
      const item = deepClone(this.children[tabIndex].children[newIndex])
      if (!item.prop) item.prop = createId(item.type)
      this.$set(this.children[tabIndex].children, newIndex, item)
      this.$emit('change')
      this.selectWidget = this.children[tabIndex].children[newIndex]
      // }
    },
    onSelectWidgetTabs(tabIndex, index) {
      this.selectWidget = this.children[tabIndex].children[index]
    },
    onWidgetTabsDelete(tabIndex, index) {
      this.$confirm(`是否删除所选组件?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$nextTick(() => {
            this.children[tabIndex].children.splice(index, 1)
            this.$emit('change')
            this.selectWidget = {}
          })
        })
        .catch(() => {})
    },
    onWidgetTabsClone(tabIndex, index) {
      let cloneData = deepClone(this.children[tabIndex].children[index])
      const type = cloneData.type
      cloneData.prop = createId(type)
      this.children[tabIndex].children.splice(index, 0, cloneData)
      this.$nextTick(() => {
        this.$emit('change')
        this.onSelectWidgetTabs(tabIndex, index + 1)
      })
    },
    onWidgetTabsMove(row, tabIndex, index, direction) {
      let len = this.children[tabIndex].children.length
      let stop = direction === 'up' ? 0 : len - 1
      if (index === stop) return
      let next = direction === 'up' ? index - 1 : index + 1
      let temp = this.children[tabIndex].children[next]
      this.$set(this.children[tabIndex].children, index, temp)
      this.$set(this.children[tabIndex].children, next, row)
      this.$emit('change')
      this.onSelectWidgetTabs(tabIndex, next)
    },
    onTab() {
      if (this.category === 'report') {
        let list = this.children.filter((child) => {
          return child.name === this.option.currentTab
        })
        this.updateEcharts(list)
      }
    },
    updateEcharts(list = []) {
      if (isEmpty(list)) return
      let stack = []
      stack = stack.concat(list)
      while (stack.length) {
        let temp = stack.shift()
        if (temp.children) {
          stack = stack.concat(temp.children)
        }
        if (temp?.type && temp?.type.includes('echart')) {
          temp.width = temp.width === '100%' ? '99.9%' : '100%'
        }
      }
      // return list
    },
    init() {
      this.children.forEach((child) => {
        if (isEmpty(child.name)) {
          child.name = createId()
        }
      })
      if (isEmpty(this.option.currentTab)) {
        let active = !isEmpty(this.children) ? this.children[0]['name'] : ''
        this.option.currentTab = active
      }
    }
  },
  created() {
    this.init()
  }
}
</script>
<style lang='scss' scoped>
@import '@/dragComponents/styles/variables.scss';

.drag-tabs {
  width: 100%;
  box-sizing: border-box;

  &-panel {
    min-height: 300px;
    border: 1px dashed #e5e4e9;

    &__noborder {
      border: 0;
    }
  }

  &-item {
    position: relative;
    box-sizing: border-box;
    text-align: left;
    margin-bottom: 15px;

    &:last-child {
      margin-bottom: 0;
    }

    &__content {
      position: relative;
    }

    &__action {
      position: absolute;
      bottom: -8px;
      right: 0px;
      z-index: 1001;

      i {
        font-size: 14px;
      }
    }
  }
}
</style>
